console.log("script custom-header")

document.addEventListener('DOMContentLoaded', function() {
  const dropdowns = document.querySelectorAll('.dropdown-container');
  
    dropdowns.forEach(dropdown => {
        const summary = dropdown.querySelector('summary');
    
        summary.addEventListener('click', function (e) {
          // Check if the current dropdown is already open
          const isOpen = dropdown.open;
    
          // Close all dropdowns
          dropdowns.forEach(d => d.open = false);
    
          // Toggle the clicked one (open it if it was closed)
          dropdown.open = !isOpen;
    
          // Prevent default behavior if needed
          e.preventDefault();
        });
      });;
  
  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.dropdown-container')) {
      dropdowns.forEach(dropdown => {
        dropdown.open = false;
      });
    }
  });
});